import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('post-media')
export class PostMedia extends LitElement {
  createRenderRoot() { return this }

  @property({ type: Array }) mediaUrls: string[] = [];
  @property({ type: String }) mediaPlayerId = '';

  render() {
    if (!this.mediaUrls.length) return null;

    return html`
      <div class="carousel w-full rounded max-h-[50vh]">
        ${this.mediaUrls.map((url, index) => html`
          <div id="media-${index}" class="carousel-item w-full">
            ${this.renderMedia(url)}
          </div>
        `)}
      </div>
      <div class="flex justify-center gap-2 py-2">
        ${this.mediaUrls.map((_, index) => html`
          <a href="#media-${index}" class="btn btn-xs btn-outline btn-neutral-content">${index + 1}</a>
        `)}
      </div>
    `;
  }

  renderMedia(url: string) {
    const isHls = url.endsWith('.m3u8');
    const isVideo = isHls || url.endsWith('.mp4') || url.endsWith('.webm');

    if (isVideo) {
      return html`
        <media-player
          id=${this.mediaPlayerId}
          class="max-h-full h-full w-full"
          controls
          crossorigin
          playsinline
          muted
          loop
          load="eager"
        >
          <media-provider class="h-full">
            <source src="${url}" type="${isHls ? 'application/x-mpegURL' : 'video/mp4'}" />
          </media-provider>
        </media-player>
      `;
    }

    return html`<img src="${url}" class="w-full object-contain rounded" />`;
  }
}

